/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { OperatorePredicato } from './operatore-predicato';
import { TipoNodoEleggibilita } from './tipo-nodo-eleggibilita';
import { FontePredicato } from './fonte-predicato';
import { LogicaJoin } from './logica-join';


export interface GraduatoriaEligibilitaNodoForm { 
    tipo_nodo: TipoNodoEleggibilita;
    ordine: number;
    logica_join?: LogicaJoin;
    fonte?: FontePredicato;
    operatore?: OperatorePredicato;
    attributo_id?: string;
    attributo_valore_id?: string;
    valore_int?: number;
    valore_int_max?: number;
    valore_double?: number;
    valore_double_max?: number;
    valore_bool?: boolean;
    valore_testo?: string;
    valore_date?: string;
    valore_date_max?: string;
    figli?: Array<GraduatoriaEligibilitaNodoForm>;
}



